import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function MJGAdminHappy({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 177.1232605 174.6164856"
      enableBackground="new 0 0 177.1232605 174.9942627"
      xmlSpace="preserve"
    >
      <g id="tyche">
        <g id="happy_4_">
          <ellipse
            fill="#A6E3F9"
            cx="72.0000381"
            cy="71.9977722"
            rx="71.9999924"
            ry="71.9977722"
          />
          <g>
            <g>
              <defs>
                <ellipse
                  id="SVGID_1_"
                  cx="72.0000153"
                  cy="72.0022278"
                  rx="71.9999847"
                  ry="71.997757"
                />
              </defs>
              <clipPath id="SVGID_2_">
                <use
                  xlinkHref="#SVGID_1_"
                  overflow="visible"
                />
              </clipPath>
              <g clipPath="url(#SVGID_2_)">
                <rect
                  x="4.0738492"
                  y="102.0344238"
                  transform="matrix(0.5533773 -0.8329307 0.8329307 0.5533773 -82.9563217 53.8345413)"
                  fill="#00AFEC"
                  width="9.2949057"
                  height="4.4753795"
                />
                <rect
                  x="75.2757111"
                  y="-4.6385264"
                  transform="matrix(0.8660321 -0.4999884 0.4999884 0.8660321 10.3798475 38.757)"
                  fill="#00AFEC"
                  width="4.4753876"
                  height="9.2948933"
                />
                <rect
                  x="117.2760315"
                  y="120.2496262"
                  transform="matrix(0.8124409 -0.5830436 0.5830436 0.8124409 -50.4045563 93.1072922)"
                  fill="#FFE502"
                  width="4.4753723"
                  height="9.2949219"
                />
                <rect
                  x="127.7464676"
                  y="54.6979904"
                  transform="matrix(0.8124409 -0.5830436 0.5830436 0.8124409 -10.2212696 86.9172058)"
                  fill="#FFE502"
                  width="4.4753799"
                  height="9.2949181"
                />
                <rect
                  x="9.4039412"
                  y="64.8130493"
                  transform="matrix(0.456615 -0.8896644 0.8896644 0.456615 -52.0173531 48.9353867)"
                  fill="#FFE502"
                  width="9.2948837"
                  height="4.4753933"
                />
                <rect
                  x="121.9771957"
                  y="73.2491837"
                  transform="matrix(0.7661791 -0.6426271 0.6426271 0.7661791 -21.0144672 98.0377121)"
                  fill="#00AFEC"
                  width="4.4753647"
                  height="9.2949371"
                />
                <rect
                  x="17.0193691"
                  y="17.9265175"
                  transform="matrix(0.5533773 -0.8329307 0.8329307 0.5533773 -7.1184921 27.0527573)"
                  fill="#FFE502"
                  width="9.2949085"
                  height="4.4753795"
                />
                <rect
                  x="92.8410873"
                  y="17.9265213"
                  transform="matrix(0.5533773 -0.8329307 0.8329307 0.5533773 26.7452106 90.2070007)"
                  fill="#FFE502"
                  width="9.2949085"
                  height="4.4753795"
                />
                <rect
                  x="4.5821948"
                  y="40.4053192"
                  transform="matrix(0.7661791 -0.6426271 0.6426271 0.7661791 -27.3575153 14.9169226)"
                  fill="#00AFEC"
                  width="4.4753652"
                  height="9.2949409"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <ellipse id="SVGID_3_" cx="72.0000381" cy="72.0022278" rx="71.9999924" ry="71.9977722" />
              </defs>
              <clipPath id="SVGID_4_">
                <use
                  xlinkHref="#SVGID_3_"
                  overflow="visible"
                />
              </clipPath>
              <g
                id="profil_5_"
                clipPath="url(#SVGID_4_)"
              >
                <path
                  fill="#FF7F29"
                  d="M68.4679642,16.6284885l-6.1435928,0.7317886l6.8884659,74.2166367l14.3838959-1.1102219 c12.4629517-0.9618683,21.3595963-12.4902649,19.1310577-24.7899933l-4.7625046-26.2843399 C95.4235153,25.3638897,82.6824799,15.5313292,68.4679642,16.6284885z"
                />
                <path
                  fill="#FFE500"
                  d="M81.7342529,107.6729965c-6.4197083,4.2170334-8.2054367,12.8398056-3.9885483,19.260025 c0.337738,0.5141449,0.7131577,0.9872513,1.1037521,1.4412155l-0.0113754,0.0084229l36.2861481,42.6131897 l18.106163-10.2611084l-32.235878-49.0736923C96.7774887,105.2413483,88.1541901,103.4554749,81.7342529,107.6729965z"
                />
                <circle
                  fill="#FFE500"
                  cx="88.9811935"
                  cy="119.4544067"
                  r="14.3075523"
                />
                <path
                  fill="#FFE500"
                  d="M103.2110062,120.1159134l-3.7037888,80.0356827H48.3280029l-21.1496449-84.0514832 c-1.3990574-5.5602417,2.8048306-10.9532013,8.5385265-10.9532013h53.2018623 C97.0802155,105.1469116,103.5882797,111.9631424,103.2110062,120.1159134z"
                />
                <path
                  fill="#FFE500"
                  d="M45.8062859,108.8342438c-5.8651047-5.294899-14.9121017-4.8327637-20.2075481,1.032341 c-0.4240532,0.4697342-0.7974796,0.9663162-1.1479053,1.4730225l-0.0113354-0.00914L-9.9127178,161.006073 l16.2764931,12.8699799L46.83918,129.0419006C52.1340752,123.176796,51.6719437,114.1292496,45.8062859,108.8342438z"
                />
                <path
                  fill="#283042"
                  d="M105.5566559,54.8042068c-0.0118866,0.0095215-0.0118866,0.0095215-0.0118866,0.0095215"
                />
                <path
                  fill="#FDC9A3"
                  d="M57.6148605,107.0715485c1.0777969,6.5987549,7.3008118,11.0742722,13.8995667,9.9964676 c6.5987549-1.0777969,11.0742645-7.3009186,9.9964676-13.8996735s-7.3009262-11.0742645-13.8995667-9.9964676 C61.0125732,94.2496719,56.5369492,100.4728012,57.6148605,107.0715485z"
                />
                <polygon
                  fill="#FDC9A3"
                  points="81.5108948,103.1683426 57.6148605,107.0715485 52.8086205,77.6468582 53.5096893,77.5323486
                  76.7047653,73.7437592"
                />
                <path
                  fill="#FDC9A3"
                  d="M68.0141296,24.2352238l-1.8586655,0.3036518 c-11.8620567,1.9374619-19.9074173,13.1242065-17.969841,24.9861603l6.6085472,40.4593391l22.498188-3.6748428 c11.2986755-1.8455658,18.9619064-12.500946,17.1163406-23.7995148l-3.5705032-21.8599586 C89.0683517,29.8145103,78.8495712,22.4653797,68.0141296,24.2352238z"
                />
                <line
                  fill="none"
                  stroke="#0E0E11"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  x1="81.5610199"
                  y1="50.9541702"
                  x2="87.3673019"
                  y2="50.5129967"
                />
                <line
                  fill="none"
                  stroke="#0E0E11"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  x1="66.5531006"
                  y1="51.5978508"
                  x2="72.8557053"
                  y2="51.2154884"
                />
                <path
                  fill="#FDC9A3"
                  d="M48.8671875,65.799263l4.9390297-0.8031158l-0.8003387-4.9288788 c-0.4419975-2.7220917-3.0116615-4.5692101-5.739357-4.1256828l0,0 c-2.7277832,0.4435463-4.5806847,3.0099106-4.1385994,5.7319794l0,0 C43.5699387,64.3957443,46.1395149,66.2428818,48.8671875,65.799263z"
                />

                <ellipse
                  transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.0874877 3.9798167)"
                  fill="#0E0E11"
                  cx="69.9409256"
                  cy="57.4467468"
                  rx="1.6411057"
                  ry="2.1177406"
                />

                <ellipse
                  transform="matrix(0.9984514 -0.0556306 0.0556306 0.9984514 -3.0217559 4.7652969)"
                  fill="#0E0E11"
                  cx="84.0824356"
                  cy="56.6588249"
                  rx="1.6411057"
                  ry="2.1177406"
                />
                <path
                  fill="#FF7F29"
                  d="M62.8640633,92.2811737l-9.5323372,0.7357101 c-9.1671486,0.7076263-16.8931656-6.7528992-16.5065804-15.9391479l1.4026413-33.3281898 c0.5919151-14.0651932,11.6031761-25.4683609,25.639019-26.551754l1.2852859-0.0991859l2.0878372,15.3381233 c0.4040985,5.2352943-1.0067062,14.4091072-3.4134102,19.0759697l-6.6670494,9.9539261 c-5.0052185,9.7057076-0.9119148,22.1268272,5.7044945,30.814579L62.8640633,92.2811737z"
                />
                <path
                  fill="#FF7F29"
                  d="M62.6498756,24.1440258l14.2547493,14.9281864 c5.1092377,5.3505516,12.3512955,8.1238594,19.7275391,7.5545235l0,0l1.0328827,13.3824348L96.049614,39.0793343 c-0.7421722-9.6150169-9.1383057-16.8079872-18.7533264-16.0658169L62.6498756,24.1440258z"
                />
                <path
                  fill="#FFE500"
                  d="M65.9319687,140.5347137l21.1364441-16.0259933l16.9491348,22.3457718l-0.0121384,0.0089722 c0.9427185,1.2424774,1.6917572,2.6633301,2.1599045,4.2480011c2.0742188,7.022995-1.937355,14.3974762-8.9602585,16.4717102 c-5.4382477,1.6065826-11.0764008-0.4471436-14.3119125-4.7121735l-0.0121384,0.009491L65.9319687,140.5347137z"
                />
                <path
                  fill="#FFFFFF"
                  d="M93.454277,168.1285248c-2.6762924,0-5.271904-0.8110504-7.5050278-2.3454285l1.1553726-1.6812439 c2.7838898,1.9140015,6.2879486,2.479538,9.5230484,1.5251007c2.8734436-0.8487854,5.2449722-2.766037,6.6763382-5.3986816 c1.4332047-2.6325226,1.7539673-5.6650696,0.9053879-8.539032c-0.3805313-1.2858124-0.9960556-2.4948425-1.8287277-3.5932007 l-1.2479782-1.6448212l0.0128479-0.0087738l-8.1224899-10.7075958l1.6254578-1.2327881l9.3776093,12.3639526 l-0.0110168,0.0087738c0.9770966,1.2923431,1.7012405,2.717392,2.1504135,4.2361603 c1.0040207,3.3970642,0.6235886,6.9809875-1.0696945,10.0921783c-1.691246,3.1109772-4.4941025,5.3769531-7.8904572,6.3800507 C95.9802246,167.9451447,94.7182693,168.1285248,93.454277,168.1285248z"
                />
                <path
                  fill="#FFFFFF"
                  d="M63.8107224,168.1285248c-2.6762848,0-5.2719994-0.8110504-7.5040054-2.34552l1.1553726-1.6810455 c2.7838898,1.9138947,6.288868,2.4794312,9.5219345,1.5249939c1.2310486-0.3635101,2.3744888-0.9232483,3.4014511-1.6638031 l1.1932144,1.6541138c-1.2132034,0.8756104-2.5648117,1.5371246-4.016983,1.9660034 C66.3375931,167.944931,65.0756378,168.1285248,63.8107224,168.1285248z"
                />
                <path
                  fill="#FFE500"
                  d="M-8.304491,174.965744c4.3783436,3.8374481,11.0385962,3.3989868,14.8760357-0.9793549 c3.8375511-4.3783417,3.3989811-11.0386047-0.9793634-14.8761444 c-4.3783441-3.8374481-11.0385962-3.3989868-14.8760357,0.9794617 C-13.1214066,164.4680634-12.6828356,171.1283112-8.304491,174.965744z"
                />
                <polygon
                  fill="#FFE500"
                  points="7.2635746,165.4305878 31.1323967,209.5862274 20.6612473,217.7761688 -10.5730677,172.1364288"
                />
                <path
                  fill="#FFE500"
                  d="M117.0167389,155.1039581c4.8361282-3.2415466,11.3844299-1.9489136,14.6259918,2.887207 c3.2416687,4.8361511,1.9489288,11.3844452-2.8872223,14.6261139 c-4.8361282,3.2415466-11.3844376,1.9489136-14.6259766-2.8873138 C110.8878632,164.8938141,112.180603,158.34552,117.0167389,155.1039581z"
                />
                <path
                  fill="#FDC9A3"
                  d="M172.5358734,103.3054886c3.0120392,3.2155075,2.8471527,8.2638855-0.3682404,11.2758484 c-3.2154999,3.0120392-8.2638855,2.8471527-11.2759399-0.3682556 c-3.0120392-3.2155075-2.8471527-8.2638855,0.3683472-11.2759323 C164.4754333,99.9251862,169.523819,100.0900726,172.5358734,103.3054886z"
                />
                <polygon
                  fill="#FDC9A3"
                  points="159.8433685,104.7008667 151.4827271,116.1998901 161.97995,124.3563995 172.1676331,114.581337"
                />
                <path
                  fill="#FDC9A3"
                  d="M160.8320618,115.0281143c-2.8915405-2.250946-7.0603485-1.731636-9.3112946,1.1600189 c-2.250946,2.8915405-1.7316437,7.0603409,1.1600189,9.3112946c2.8915405,2.250946,7.0604553,1.7316437,9.3112946-1.1600113 C164.2430267,121.4478683,163.7237244,117.2789612,160.8320618,115.0281143z"
                />
                <polygon
                  fill="#FFE500"
                  points="131.1314697,170.4285583 161.97995,124.3563995 151.2550964,116.3808365 114.4026489,157.6175385"
                />
                <path
                  fill="#FDC9A3"
                  d="M172.4667816,96.307579l-8.6971893,11.8533096 c-0.4496613,0.6128387-1.3189697,0.7463531-1.9318085,0.2966919l-0.580307-0.4257889 c-0.6128387-0.4496613-0.7463379-1.3189774-0.2966766-1.9318161l8.6971741-11.8533173 c0.4496613-0.6128387,1.318985-0.7463455,1.9318237-0.2966843l0.5802917,0.4257812 C172.7829285,94.8254166,172.9164429,95.6947403,172.4667816,96.307579z"
                />
              </g>
            </g>
          </g>
          <path
            fill="#FFE500"
            d="M84.1662216,107.8860016c-6.4197083,4.2170334-8.2054367,12.8398056-3.9885483,19.2600327 c0.337738,0.5141373,0.7131653,0.9872513,1.1037521,1.4412003l-0.0113754,0.0084229l36.2861481,42.613205l18.1061554-10.2611237 l-32.2358704-49.0736847C99.2094574,105.4543533,90.5861664,103.6684875,84.1662216,107.8860016z"
          />
          <path
            fill="#FFE500"
            d="M119.4487076,155.3169708c4.8361282-3.2415619,11.3844376-1.9489288,14.6259842,2.887207 c3.2416687,4.8361359,1.9489288,11.3844299-2.887207,14.6260986c-4.8361359,3.2415619-11.3844452,1.9489288-14.6259842-2.8873138 C113.3198318,165.1068268,114.6125793,158.5585327,119.4487076,155.3169708z"
          />
          <path
            fill="#FDC9A3"
            d="M174.9678497,103.5184937c3.0120392,3.2155075,2.8471527,8.2638855-0.3682404,11.2758484 c-3.2155151,3.0120468-8.2638855,2.8471527-11.2759552-0.3682556c-3.0120392-3.2155075-2.8471527-8.2638855,0.3683624-11.2759247 C166.9073944,100.1381912,171.95578,100.3030777,174.9678497,103.5184937z"
          />
          <polygon
            fill="#FDC9A3"
            points="162.2753296,104.9138718 153.9146881,116.4128952 164.411911,124.5694046 174.5996094,114.794342"
          />
          <path
            fill="#FDC9A3"
            d="M163.2640381,115.2411194c-2.8915405-2.250946-7.0603485-1.731636-9.3112946,1.1600189 c-2.250946,2.8915405-1.7316437,7.0603409,1.1600037,9.3112946c2.8915405,2.250946,7.0604553,1.7316437,9.3112946-1.1600113 C166.6749878,121.660881,166.1556854,117.4919662,163.2640381,115.2411194z"
          />
          <polygon
            fill="#FFE500"
            points="133.5634308,170.641571 164.411911,124.5694046 153.6870728,116.5938416 116.8346176,157.8305359"
          />
          <path
            fill="#FDC9A3"
            d="M174.8987427,96.5205841l-8.6971741,11.8533173 c-0.4496613,0.6128387-1.318985,0.7463455-1.9318237,0.2966843l-0.5802917-0.4257889 c-0.6128387-0.4496613-0.7463531-1.3189774-0.2966919-1.9318161l8.6971893-11.8533173 c0.4496613-0.6128387,1.3189697-0.7463455,1.9318085-0.2966843l0.580307,0.4257889 C175.2149048,95.0384293,175.3484039,95.9077454,174.8987427,96.5205841z"
          />
          <path
            fill="#FFE500"
            d="M61.5141296,39.957283c-0.267662-1.0706139-1.1812439-32.1366425-1.1812439-32.1366425 l19.4012375,26.2482758L61.5141296,39.957283z"
          />
          <path
            fill="#FFFFFF"
            d="M72.6994247,71.4168854c0.3737946,3.3222427,3.370018,5.7124329,6.6922531,5.3386383 c3.3222427-0.3737869,5.7124329-3.370018,5.3386459-6.6922531L72.6994247,71.4168854z"
          />
        </g>
      </g>
    </svg>
  );
}

export default MJGAdminHappy;
